import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import IframePanel from '../../../../components/Editor/EditPanel/IframePanel';

interface IframePanelOwnProps {
	page: number;
}

const mapStateToProps = (state: StoreState, { page }: IframePanelOwnProps) => {
	const {
		editor: {
			activeItem: { id },
			editableIframes,
		},
	} = state;

	const { src, defaultSrc } = editableIframes[page][id];

	return {
		page,
		id,
		src,
		defaultSrc,
	};
};

export default connect(mapStateToProps)(IframePanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/IframePanel/index.tsx